import { Container } from '../../../odie';
import { SparkleAnimation } from '../../animations/SparkleAnimation';

import { ZombieBlockProps } from '../../defs/block';
import { config } from '../../defs/config';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

const manifest = {
  zombie: 'zombie/block.zombie.png',
};

export class ZombieBlockView extends Container {
  public sparkles: SparkleAnimation;

  constructor(props: ZombieBlockProps) {
    super();
    const size = config.tile.size * 0.75;
    this.addChild(new FitWidthBlockSprite(manifest.zombie, props));
    this.sparkles = new SparkleAnimation({ width: size, height: size });
    this.addChild(this.sparkles);
    this.sparkles.start();
    blockPositionView(this, props);
    this.y += 1;
  }

  public static assets(): string[] {
    return [manifest.zombie];
  }
}
